import EducationForm from './educationForm'
export default EducationForm
